import { render, staticRenderFns } from "./SelectDealer.vue?vue&type=template&id=71d46138"
import script from "./SelectDealer.vue?vue&type=script&lang=js"
export * from "./SelectDealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports